export default __webpack_public_path__ + "static/media/Road safety impacts.2c7111b4.pdf";